const env = { ...import.meta.env };
const templated = [
  "PUBLIC_API_HOST",
  "PUBLIC_CHECKOUT_HOST",
  "PUBLIC_DOMAIN",
  "PUBLIC_B2C_ASSETS_HOST",
  "PUBLIC_RESIZED_ASSETS_HOST",
  "PUBLIC_ASSETS_HOST",
  "PUBLIC_ORIGINAL_ASSETS_HOST",
];

for (const [key, value] of Object.entries(env)) {
  if (templated.includes(key)) {
    env[key] = value
        .replace('{hostname}', window.location.hostname)
        .replace('{domain}', window.location.hostname.replace('www.', ''));
  }
}

export const getEnv = function () {
  return env;
};